import {DependencyDef} from "../parser/definition/types/DependencyDef";

export function compileDependencies(
  dependencyDefs: Array<DependencyDef>
): Record<string, string> {
  return dependencyDefs.reduce((result, dependencyDef) => {
    result[dependencyDef.name] = "\"*\"";
    return result;
  }, {} as Record<string, string>);
}
